<template>
  <BaseTableItemAction
    v-can:[showPermission]
    v-on="$listeners"
    v-bind="$attrs"
    icon="mdi-eye"
    actionName="عرض التفاصيل"
    :to="'/training-programs/' + item.id"
  >
    <slot></slot>
  </BaseTableItemAction>
</template>

<script>
import { READ_TPS_PERMISSION } from "@/core/statics/Permissions";

export default {
  props: {
    item: Object,
  },
  data() {
    return {
      showPermission: READ_TPS_PERMISSION,
    };
  },
};
</script>
